import { Middleware } from '@reduxjs/toolkit';

/**
 * Middleware for auto-clearing old errors
 * Automatically clears error messages after 5 seconds
 */
export const errorAutoClearMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action);

  // Auto-clear errors after 5 seconds
  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    action.type === 'reportUI/setError' &&
    'payload' in action
  ) {
    setTimeout(() => {
      const state = store.getState() as any;
      const typedAction = action as { type: string; payload?: { timestamp?: number } };
      // Only clear if the error is still the same (user hasn't dismissed or new error appeared)
      if (state.reportUI?.error && state.reportUI.error.timestamp === typedAction.payload?.timestamp) {
        store.dispatch({ type: 'reportUI/clearError' });
      }
    }, 5000);
  }

  return result;
};

/**
 * Middleware for multi-tab synchronization
 * Syncs filter changes across browser tabs using storage events
 */
export const multiTabSyncMiddleware: Middleware = () => {
  // Listen to storage events from other tabs
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', (event) => {
      if (event.key === 'cashierpos_report_filters' && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          if (parsed.version === 1 && parsed.data) {
            // Notify user about the change
            console.log('Report filters updated in another tab');
            // Optionally dispatch an action to reload filters
            // store.dispatch({ type: 'reportFilter/loadFilters' });
          }
        } catch (error) {
          console.error('Error parsing storage event:', error);
        }
      }
    });
  }

  return (next) => (action) => {
    return next(action);
  };
};

/**
 * Combined middleware
 */
export const reportMiddleware: Middleware[] = [errorAutoClearMiddleware, multiTabSyncMiddleware];
